//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      isScaleModeFull: false,
    }
  },
  created() {
    if (this.isPad) {
      this.getScaleMode()
    }
  },
  methods: {
    closeWebApp() {
      this.$emit('backHandle')
    },
    async getScaleMode() {
      await this.$runWorkH5.jssdkReady()
      let _this = this
      tt.getPadDisplayScaleMode({
        success(res) {
          _this.isScaleModeFull = res.displayScaleMode == 'fullScreen'
        },
        fail(res) {
          console.log(`getPadDisplayScaleMode fail: ${JSON.stringify(res)}`)
        },
      })
    },
    async togglePadFullScreen() {
      await this.$runWorkH5.jssdkReady()
      let _this = this
      let mode = !_this.isScaleModeFull ? 'fullScreen' : 'allVisible'
      tt.togglePadFullScreen({
        displayScaleMode: mode,
        success(res) {
          _this.isScaleModeFull = !_this.isScaleModeFull
          console.log(JSON.stringify(res))
        },
        fail(res) {
          console.log(`togglePadFullScreen fail: ${JSON.stringify(res)}`)
        },
      })
    },
  },
}
